import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onGetFaq } from "../../redux/homeAction";
import Loader from "../../componets/loader/Loader";

const FAQSection = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const getGetFaq = useSelector((state) => state.home.getGetFaq);

  useEffect(() => {
    setLoader(true);
    dispatch(onGetFaq(setLoader));
  }, []);

  console.log('FAQ Data:', getGetFaq); // Debug log

  return (
    <section className="faq">
      <div className="container">
        <h1 className="h1_60">FAQ</h1>
        <div className="faq-section">
          {loader ? (
            <div className="mt-4 mb-4 text-center">
              <Loader />
            </div>
          ) : (
            <div className="faq_accordios">
              <div className="accordion" id="accordionExample">
                {Array.isArray(getGetFaq) && getGetFaq.length > 0 ? (
                  getGetFaq.map((data, i) => (
                    <div className="accordion-item" key={data.id}>
                      <h2 className="accordion-header" id={`heading${data.id}`}>
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${data.id}`}
                          aria-expanded={i === 0 ? "true" : "false"}
                          aria-controls={`collapse${data.id}`}
                        >
                          {data.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse${data.id}`}
                        className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                        aria-labelledby={`heading${data.id}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div 
                          className="accordion-body"
                          dangerouslySetInnerHTML={{ __html: data.answer }}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>No FAQ items available</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
